/* FootNest „Рамката" — reveal + corner-draw. Idempotent: safe to include
   from multiple sections (guard prevents double-init). transform/opacity only. */
(function(){
  if (window.__fnRamkaInit) return;
  window.__fnRamkaInit = true;

  function boot(){
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sel = '.fn-rv, .fn-frame';
    var nodes = document.querySelectorAll(sel);
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el){ el.classList.add('fn-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('fn-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function(el){ io.observe(el); });

    // Failsafe: reveal anything already in the viewport on load. The observer's
    // initial async tick can miss above-the-fold nodes during load/layout shift,
    // which would leave the hero (LCP) blank until the first scroll.
    function revealInView(){
      var vh = window.innerHeight || document.documentElement.clientHeight;
      nodes.forEach(function(el){
        if (el.classList.contains('fn-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0){ el.classList.add('fn-in'); io.unobserve(el); }
      });
    }
    requestAnimationFrame(revealInView);
    window.addEventListener('load', revealInView);

    // Autoplay muted UGC videos only while in view (reliable + light).
    var vids = document.querySelectorAll('.fn-vid video');
    if (vids.length){
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var v = e.target;
          if (e.isIntersecting){ v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function(v){ v.muted = true; vio.observe(v); });

      // Sound toggle: off by default; tap unmutes this clip and mutes the rest.
      function setSound(v, on){
        v.muted = !on;
        var btn = v.parentNode.querySelector('.fn-sound');
        if (btn){ btn.setAttribute('aria-pressed', on ? 'true':'false');
          btn.setAttribute('aria-label', on ? 'Спри звука':'Пусни звук'); }
        v.parentNode.classList.toggle('fn-audio-on', on);
      }
      document.querySelectorAll('.fn-vid .fn-sound').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var v = btn.parentNode.querySelector('video'); if (!v) return;
          var turnOn = v.muted;
          vids.forEach(function(o){ if (o !== v) setSound(o, false); });
          setSound(v, turnOn);
          if (turnOn){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        });
      });
      // Re-mute a clip when it leaves the viewport.
      var mio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (!e.isIntersecting && !e.target.muted) setSound(e.target, false); });
      }, { threshold: 0.25 });
      vids.forEach(function(v){ mio.observe(v); });
    }

    // Re-scan when Shopify's theme editor injects/reorders a section.
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(){
        document.querySelectorAll(sel).forEach(function(el){
          if (!el.classList.contains('fn-in')) io.observe(el);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
